import React, { useState, useEffect } from 'react'
import { Panel, Table, Grid, Row, Col } from 'rsuite'
import { budgetFormat } from '../../../utils/formatterUtil'

export default function WithdrawRequestStatusWidget(props) {
  const { schema, header, isCloseProject, isSubpanel } = props
  const { Column, HeaderCell, Cell } = Table

  const [totalBudget, setTotalBudget] = useState()
  const [totalRequest, setTotalRequest] = useState()
  const [totalRemain, setTotalRemain] = useState()

  useEffect(() => {
    if (schema?.values && schema?.values.length > 0) {
      let _totalBudget = 0
      let _totalRequest = 0
      let _totalRemain = 0
      schema.values.forEach((item) => {
        _totalBudget = _totalBudget + item.installmentAmt

        if (item.statusCode == 4) {
          _totalRequest = _totalRequest + item.requestAmt
        }

        //_totalRemain = _totalRemain + item.remainAmt
      })
      _totalRemain = _totalBudget - _totalRequest

      setTotalBudget(budgetFormat(_totalBudget))
      setTotalRequest(budgetFormat(_totalRequest))
      setTotalRemain(budgetFormat(_totalRemain))
    }
  }, [schema])

  return (
    <div>
      <Panel
        header={header || schema?.header}
        collapsible
        defaultExpanded
        bordered
        shaded={!isSubpanel}
      >
        {schema?.budgetPlans &&
        <Row>
          {schema?.budgetPlans?.map((item, index)=> {
            console.log('item', item)
            return (<p key={index}><b>{item.budgetPlanLabel}</b></p>)
          })}
          <br />
        </Row>}
        <Row>
          <Col xs={24} sm={10} md={1} lg={1} style={{ width: 150 }}>
            <h6>{`งบประมาณโครงการ`}</h6>
          </Col>

          <Col xs={20} sm={12} md={10} lg={10} style={{ width: 150, textAlign: 'end' }}>
            <h6>{`${totalBudget ? totalBudget.toLocaleString() : 0}`}</h6>
          </Col>

          <Col xs={4} sm={2} md={1} lg={1}>
            <h6>{`บาท`}</h6>
          </Col>
        </Row>
        <br />

        <Row>
          <Col xs={24} sm={10} md={1} lg={1} style={{ width: 150 }}>
            <h6>{`อนุมัติเบิกไปแล้ว`}</h6>
          </Col>

          <Col xs={20} sm={12} md={10} lg={10} style={{ width: 150, textAlign: 'end' }}>
            <h6>{`${totalRequest ? totalRequest.toLocaleString() : 0}`}</h6>
          </Col>

          <Col xs={4} sm={2} md={1} lg={1}>
            <h6>{`บาท`}</h6>
          </Col>
        </Row>
        <br />

        <Row>
          <Col xs={24} sm={10} md={1} lg={1} style={{ width: 150 }}>
            <h6>{`เงินคงเหลือเบิก`}</h6>
          </Col>

          <Col xs={20} sm={12} md={10} lg={10} style={{ width: 150, textAlign: 'end' }}>
            <h6>{`${totalRemain ? totalRemain.toLocaleString() : 0}`}</h6>
          </Col>

          <Col xs={4} sm={2} md={1} lg={1}>
            <h6>{`บาท`}</h6>
          </Col>
        </Row>

        <Table wordWrap autoHeight data={schema.values} style={{ marginTop: '20px' }}>
          <Column align="center" width={58} fixed>
            <HeaderCell>
              <span>งวดที่</span>
            </HeaderCell>
            <Cell dataKey="installmentNo" />
          </Column>

          <Column width={130}>
            <HeaderCell>
              <span>วันที่เริ่มต้น</span>
            </HeaderCell>
            <Cell dataKey="startDate" />
          </Column>

          <Column width={130}>
            <HeaderCell>
              <span>วันที่สิ้นสุด</span>
            </HeaderCell>
            <Cell dataKey="endDate" />
          </Column>

          <Column width={130}>
            <HeaderCell>
              <span>กำหนดส่งผลงาน</span>
            </HeaderCell>
            <Cell dataKey="deliveryDate" />
          </Column>

          <Column width={120} align="center">
            <HeaderCell>
              <span>สถานะอนุมัติ</span>
            </HeaderCell>
            <Cell dataKey="statusName" />
          </Column>

          {!isCloseProject && (
            <Column width={100}>
              <HeaderCell>
                <span>PV No.</span>
              </HeaderCell>
              <Cell dataKey="pvNo" />
            </Column>
          )}

          {!isCloseProject && (
            <Column width={100}>
              <HeaderCell>
                <span>PV date</span>
              </HeaderCell>
              <Cell dataKey="pvDate" />
            </Column>
          )}

          <Column width={160}>
            <HeaderCell>
              <span>วันที่โอนเข้าบัญชี</span>
            </HeaderCell>
            <Cell dataKey="transferDate" />
          </Column>

          <Column minWidth={160} width={180} align="right" flexGrow={1}>
            <HeaderCell>
              <span>จำนวนเงินงวด (บาท)</span>
            </HeaderCell>
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.installmentAmt)
              }}
            </Cell>
          </Column>

          <Column minWidth={160} width={180} align="right" flexGrow={1}>
            <HeaderCell>
              <span>จำนวนขอเบิก (บาท)</span>
            </HeaderCell>
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.requestAmt)
              }}
            </Cell>
          </Column>

          <Column minWidth={200} width={220} align="right" flexGrow={1}>
            <HeaderCell>
              <span>งบประมาณคงเหลือ (บาท)</span>
            </HeaderCell>
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.remainAmt)
              }}
            </Cell>
          </Column>
        </Table>

        <br />

        {/* <Table rowKey="id" autoHeight rowHeight={64} wordWrap data={schema.installmentPlan}>
          <Column width={80}>
            <HeaderCell>งวดเงิน</HeaderCell>
            <Cell>
              {(rowData) => {
                return <span>{`งวดที่ ${rowData.numInstallment}`}</span>
              }}
            </Cell>
          </Column>
          <Column flexGrow={1}>
            <HeaderCell>แผนหลัก</HeaderCell>
            <Cell dataKey="masterBudgetPlanText" />
          </Column>
          <Column width={150} align="right">
            <HeaderCell>จำนวนเงิน (บาท)</HeaderCell>
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.masterBudgetValue)
              }}
            </Cell>
          </Column>
          <Column flexGrow={1}>
            <HeaderCell>แผนรอง</HeaderCell>
            <Cell dataKey="subBudgetPlanText" />
          </Column>
          <Column width={150} align="right">
            <HeaderCell>จำนวนเงิน (บาท)</HeaderCell>
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.subBudgetValue)
              }}
            </Cell>
          </Column>
        </Table> */}
      </Panel>
    </div>
  )
}

const installmentPlan = [
  {
    id: 'ADF41DD0-5587-4E31-91FB-B2947AD12306',
    projectVersionId: '74CAD046-585E-492A-B7EB-7070A190EE0C',
    numInstallment: 1,
    masterBudgetPlanValue: '01011101',
    masterActionPlan: '01',
    masterBudgetValue: 2000000,
    masterBudgetPlanText:
      '01011101 : ขับเคลื่อนการบังคับใช้กฎหมายโดยหน่วยปฏิบัติการควบคุมเครื่องดื่มแอลกอฮอล์และผลิตภัณฑ์ยาสูบในเขตพื้นที่กรุงเทพมหานคร (คงหลือ 100,000,000.00 บาท) (คงหลือ 100,000,000.00 บาท)',
    subBudgetPlanValue: '01021101',
    subActionPlan: '01',
    subBudgetValue: 2000000,
    subBudgetPlanText:
      '01021101 : จัดตั้งศูนย์วิชาการเพาะบ่มนักจัดการปัจจัยเสี่ยงเพื่อการพัฒนาเครือข่ายนักวิชาการสาธารณสุขศาสตร์เพื่อสังคมไทยปลอดบุหรี่และปัจจัยเสี่ยงต่อสุขภาพ',
  },
]
